// Supported locale codes for Viber transactional templates, taken verbatim from the Rakuten Viber
// "Business Messages - Transactional Message Templates Solution API" spec (V3.5) "Supported Locale Codes"
// table. Values must match the exact case/format (e.g. fr_FR, es_ES, pt_BR, pt_PT, zh-Hans, zh-Hant) -
// Viber rejects templates whose `locales.lang` isn't one of these. `templateLang` at send time must match.
const viberTemplateLanguages = [
  { value: 'ar', label: 'Arabic' },
  { value: 'hy', label: 'Armenian' },
  { value: 'be', label: 'Belarusian' },
  { value: 'bs', label: 'Bosnian' },
  { value: 'bg', label: 'Bulgarian' },
  { value: 'my', label: 'Burmese' },
  { value: 'zh-Hans', label: 'Chinese (Simplified)' },
  { value: 'zh-Hant', label: 'Chinese (Traditional)' },
  { value: 'hr', label: 'Croatian' },
  { value: 'cs', label: 'Czech' },
  { value: 'da', label: 'Danish' },
  { value: 'nl', label: 'Dutch' },
  { value: 'en', label: 'English' },
  { value: 'fi', label: 'Finnish' },
  { value: 'fr_FR', label: 'French' },
  { value: 'ka', label: 'Georgian' },
  { value: 'de', label: 'German' },
  { value: 'el', label: 'Greek' },
  { value: 'he', label: 'Hebrew' },
  { value: 'hu', label: 'Hungarian' },
  { value: 'id', label: 'Indonesian' },
  { value: 'it', label: 'Italian' },
  { value: 'ja', label: 'Japanese' },
  { value: 'ne', label: 'Nepali' },
  { value: 'no', label: 'Norwegian' },
  { value: 'fa', label: 'Persian' },
  { value: 'pl', label: 'Polish' },
  { value: 'pt_BR', label: 'Portuguese (Brazil)' },
  { value: 'pt_PT', label: 'Portuguese (Portugal)' },
  { value: 'ro', label: 'Romanian' },
  { value: 'ru', label: 'Russian' },
  { value: 'sr', label: 'Serbian' },
  { value: 'sk', label: 'Slovak' },
  { value: 'sl', label: 'Slovenian' },
  { value: 'es_ES', label: 'Spanish' },
  { value: 'sv', label: 'Swedish' },
  { value: 'th', label: 'Thai' },
  { value: 'tr', label: 'Turkish' },
  { value: 'uk', label: 'Ukrainian' },
  { value: 'vi', label: 'Vietnamese' },
];

// Senders that support the transactional-template lifecycle. Link Mobility and Routee create templates
// programmatically; Mobica has no create API yet, so its templates are created in the Mobica portal from
// text Releva generates and are then linked by id (send + status check are programmatic).
export const viberTemplateSenders = ['linkMobility', 'routee', 'mobica'];

// Maps a Viber template moderation status to a Mantine badge color. Shared so the form and the
// listing cards stay in sync.
export const templateStatusColor = (status) =>
  status === 'APPROVED' ? 'green' : status === 'REJECTED' ? 'red' : status === 'PENDING' ? 'yellow' : 'gray';

export default viberTemplateLanguages;
